import React from 'react';
import { Weather, AnyWeather, Infdoor, Outdoor } from '../Icons/CustomIcons';
import { IconHeader } from './Dialog';

const OPTIONS = [
  { value: 'both', label: 'Wetterunabhängig', icon: <AnyWeather size={20} /> },
  { value: 'indoor', label: 'Drinnen', icon: <Infdoor size={20} /> },
  { value: 'outdoor', label: 'Draussen', icon: <Outdoor size={20} /> },
];

/**
 * WeatherDependence – Filtergruppe für Wetterabhängigkeit.
 *
 * Props:
 *   value        – aktuell gewählter Wert ('both' | 'indoor' | 'outdoor' | null)
 *   onChange(v)  – Callback mit neuem Wert; liefert null wenn „Alle" gewählt wird
 *   showAll      – zeigt den „Alle"-Button (Standard: false)
 *   fieldInfo    – optionaler Hilfetext für das FieldInfo-Icon
 *
 * Verwendung Filter:
 *   <WeatherDependence
 *     value={filters.indoor_outdoor}
 *     onChange={(v) => updateFilter('indoor_outdoor', v)}
 *     showAll
 *   />
 *
 * Verwendung Formular:
 *   <WeatherDependence
 *     value={formData.weatherType}
 *     onChange={(v) => setFormData(prev => ({ ...prev, weatherType: v }))}
 *     fieldInfo={info.weatherType}
 *   />
 */
export const WeatherDependence = ({ value, onChange, showAll = false, fieldInfo = '' }) => {
  const displayValue = showAll ? (value ?? 'all') : value;

  const handleClick = (val) => {
    onChange(showAll && val === 'all' ? null : val);
  };

  return (
    <div className="filter">
      <IconHeader Icon={<Weather size={20} color="#fff" />} info={fieldInfo}>
        Wetterabhängigkeit
      </IconHeader>
      <div className="filter__box">
        <div className="prop-btn-group">
          {showAll && (
            <button
              type="button"
              className={`prop-btn${displayValue === 'all' ? ' prop-btn--active' : ''}`}
              onClick={() => handleClick('all')}
            >
              Alle
            </button>
          )}
          {OPTIONS.map(({ value: val, label, icon }) => (
            <button
              key={val}
              type="button"
              className={`prop-btn${displayValue === val ? ' prop-btn--active' : ''}`}
              onClick={() => handleClick(val)}
            >
              {icon}{label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
